import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material';
import React from 'react';

const ConfirmCompletionDialog = ({
	open,
	onClose,
	onComplete,
	loading,
	disabled,
	pipelineName,
}) => {
	return (
		<Dialog
			open={open}
			onClose={(_, reason) => {
				if (reason === 'backdropClick' && !loading) {
					return false;
				} else if (!loading) {
					onClose();
				}
			}}
			maxWidth='xs'
			fullWidth={true}
			//ConfirmCompletionDialog sits in front of the complete deal dialog...
			sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
		>
			<DialogTitle>{loading ? `Completing ${pipelineName} ...` : 'Confirmation'}</DialogTitle>
			<DialogContent>
				<Typography>
					{loading ? '' : `Are you sure you want to complete this ${pipelineName}?`}
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={disabled} color='primary'>
					Cancel
				</Button>
				<Button
					onClick={onComplete}
					color='primary'
					variant='contained'
					disabled={disabled}
				>
					{loading ? <CircularProgress /> : 'Confirm'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
ConfirmCompletionDialog.displayName = 'ConfirmCompletionDialog';
export default ConfirmCompletionDialog;
